import { VOTING_STATUS_ENUM, VOTING_TYPE_ENUM, VOTING_SCOPE_ENUM } from "@antipartido-inc/contracts-ifaces"

export default {
  table: {
    title: "Title",
    status: "Status",
    type: "Type",
    participants: "Participants",
    period: "Period",
    actions: "Actions",
    searchPlaceholder: "Search votings...",
    empty: "No votings found",
    errorRetry: "Retry",
  },
  featured: {
    title: "Pinned voting",
    votes: "votes",
  },
  actions: {
    create: "Create",
    edit: "Edit",
    view: "View",
    delete: "Delete",
    publish: "Publish",
    setToActive: "Activate",
  },
  status: {
    [VOTING_STATUS_ENUM.DRAFT]: "Draft",
    [VOTING_STATUS_ENUM.UPCOMING]: "Upcoming",
    [VOTING_STATUS_ENUM.ACTIVE]: "Active",
    [VOTING_STATUS_ENUM.CLOSED]: "Closed",
  },
  type: {
    [VOTING_TYPE_ENUM.PROPOSAL]: "Proposal",
    [VOTING_TYPE_ENUM.CANDIDATE]: "Candidate",
  },
  scope: {
    [VOTING_SCOPE_ENUM.GLOBAL]: "Global",
    [VOTING_SCOPE_ENUM.LOCAL_ENTIDAD]: "Local - Entity",
    [VOTING_SCOPE_ENUM.LOCAL_DISTRITO]: "Local - District",
    [VOTING_SCOPE_ENUM.LOCAL_MUNICIPIO]: "Local - Municipality",
    [VOTING_SCOPE_ENUM.LOCAL_SECCION]: "Local - Section",
  },
  errors: {
    theFilesAreTooLarge: "The files are too large. Maximum file size is 10 MB.",
    docsTitleRequired: "All documents must have a title.",
  },
  create: {
    title: "Create Voting",
    success: "Voting created successfully",
    errors: {
      saveFailed: "Failed to create voting",
      unknown: "An unexpected error occurred. Please try again.",
    },
  },
  view: {
    title: "Voting Details",
  },
  edit: {
    title: "Edit Voting",
    success: "Voting saved successfully",
    deleteTitle: "Delete voting",
    deleteConfirm: "Are you sure you want to delete this voting?",
    publishConfirm: "Are you sure you want to publish this voting?",
    publishConfirmWithSave: "Pending changes will be saved and the voting will be published. Do you want to continue?",
    errors: {
      loadFailed: "Failed to load voting",
      saveFailed: "Failed to save voting",
      deleteFailed: "Failed to delete voting",
      publishFailed: "Failed to publish voting",
      statusChangeFailed: "Failed to change status",
      updatePublishedFailed: "Failed to update published voting",
      setVoteWindowFailed: "Failed to update voting dates",
      setVoteWindowAlreadyPending:
        "There is already a pending transaction to update voting dates. Please sign it in Safe before making new changes.",
      publishSafeProposalInProgress:
        "There is already a Safe proposal in progress for this voting. Please wait for it to complete before publishing again.",
      toggleAutoUpdateFailed: "Failed to toggle auto-update status.",
      unknown: "An unexpected error occurred. Please try again.",
    },
    pendingSafeApproval: {
      title: "Pending approval",
      description:
        "The token creation process is awaiting approval in Safe. Please sign the transaction in Safe to continue.",
    },
    pendingVoteWindowApproval: {
      title: "Pending date change approval",
      description:
        "There is a pending transaction to update the voting dates. Please sign the transaction in Safe to apply the changes.",
    },
    validation: {
      required: "This field is required",
      maxLength: "Maximum {{max}} characters ({{current}} currently)",
      publishRequirements: "To publish, the voting must have a title, a description, and at least 2 options.",
      saveRequirements: "To save, the voting must have at least a title and a description.",
      range: "Must be between {{min}} and {{max}}",
      minValue: "Must be greater than or equal to {{min}}",
    },
    fields: {
      title: "Title",
      description: "Description",
      status: "Status",
      type: "Type",
      scope: "Scope",
      visibility: "Visibility",
      startDate: "Start Date",
      endDate: "End Date",
      participants: "Participants",
      tokenName: "Token Name",
      tokenSymbol: "Token Symbol",
      tokenAddress: "Token Address",
      territorialTarget: "Territorial Target",
      entidadClave: "Entity",
      distritoClave: "District",
      municipioClave: "Municipality",
      seccion: "Section",
      selectPlaceholder: "Select...",
    },
    savePublished: "Save changes",
    autoUpdate: {
      title: "Automatic allowlist update",
      description: "When enabled, this voting's allowlist will be updated automatically.",
      enable: "Enable",
      disable: "Disable",
    },
    voteWindow: {
      button: "Change dates",
      modalTitle: "Change voting dates",
      warning: "This action will generate a blockchain transaction. Make sure the dates are correct before confirming.",
      confirm: "Confirm",
    },
    sections: {
      general: "General",
      config: "Configuration",
      token: "Token Information",
      tokenButton: "Token Configuration",
      tokenInfo:
        "Token fields are generated automatically. You don't need to modify them unless you have a specific requirement.",
      options: "Voting Options",
      documents: "Documents",
      scope: "Territorial Scope",
    },
    documents: {
      add: "Add Document",
      empty: "No documents",
      fields: {
        name: "Name",
        title: "Title",
      },
    },
    options: {
      empty: "No options yet. Add at least 2 to be able to publish.",
      add: "Add Option",
      addTitle: "Add New Option",
      editTitle: "Edit Option",
      fields: {
        title: "Title",
        description: "Description",
        key: "Key",
        votes: "Votes",
        percentage: "Percentage",
        sinkAddress: "Sink Address",
        candidateImage: "Candidate Image",
        documentFallback: "Document",
      },
      candidateImage: {
        add: "Add image",
        change: "Change image",
        empty: "No candidate image",
      },
    },
  },
  saveSuccess: {
    title: "Voting saved",
    message: "The voting has been saved successfully.",
    messageWithPublish: "The voting has been saved successfully. You can publish it now.",
    continueEditing: "Continue editing",
    goToList: "Go to list",
  },
  safeProposal: {
    title: "Voting Created",
    description: "The voting has been created successfully. It will be published and available in a few minutes.",
    openInSafe: "Open in Safe",
    fields: {
      status: "Status",
      safeTxHash: "Transaction Hash",
      safeAddress: "Safe Address",
      chainId: "Chain ID",
      nonce: "Nonce",
      threshold: "Threshold",
      signatures: "Signatures",
      proposedBy: "Proposed by",
    },
  },
}
